export default {
    ACIDENTE_AUTOMOBILISTICO: 1,
    ACIDENTE_BICICLETA: 2,
    ACIDENTE_MOTO: 3,
    ANIMAIS_INSETO: 4,
    CORPO_ESTRANHO: 5,
    CORRENTE_ELETRICA: 6,
    ESFORCO_FISICO_REPETITIVO: 7,
    MAQUINAS_EQUIPAMENTOS: 8,
    PRODUTO_QUIMICO: 9,
    QUEDA_ALTURA: 10,
    QUEDA_PRORIA_ALTURA: 11,
    SUBSTANCIA_QUENTEFRIA: 12,
    OUTROS: 13,
}